import { useEffect } from "react";
import { IHook } from "./gameCoupon.types";

export const useGameCoupon: IHook = ({ showModal }) => {
  useEffect(() => {
    if (!showModal) {
      return;
    }

    showModal();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);
};
